import { BoxStyleProps } from '../Box';
import Dropdown from '../Dropdown';
import { PopoverPlacement } from '../Popover/Popover';
import TransactionDropdownItem from './TransactionDropdownItem';

export type Transaction = {
  hash: string;
  value?: string;
  date?: string;
  link?: string;
  status?: 'confirming' | 'confirmed';
};

interface TransactionDropdownProps extends BoxStyleProps {
  className?: string;
  transactions: Array<Transaction>;
  placement?: PopoverPlacement;
}

export default function TransactionDropdown({
  className,
  placement = 'bottom-end',
  transactions,
  ...otherProps
}: TransactionDropdownProps) {
  return (
    <Dropdown
      className={className}
      label={transactions.length ? 'Transactions found' : ''}
      placement={placement}
      {...otherProps}
    >
      {transactions.map((tx) => (
        <TransactionDropdownItem key={tx?.hash} {...tx} />
      ))}
    </Dropdown>
  );
}
